import { API_KEY } from '../env.config';
export const getCoordinatesByAddress = async (address) => {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${API_KEY}`;
  const resjson = await fetch(url);
  return await resjson.json();
};
